<template>
	<div id="specialty-visit-materials">
		<!-- date -->
        <v-card flat color="lightgray">
            <v-card-text class="d-flex justify-space-between align-center">
				<div class="d-flex justify-space-between align-center primary--text ">
					<div class="d-flex align-center">
						<v-icon class="me-2" color="primary">mdi-calendar</v-icon>
						<span class="text-h5 me-2">{{moment().format('MMMM')}}</span>
						<span class="text-subtitle-2 align-self-end">{{moment().format('YYYY')}}</span>
					</div>
				</div>
            </v-card-text>
        </v-card>

		<loader v-if="loading" />
		<v-container fluid v-else>
			<v-expansion-panels v-if="specialtyMaterials.length">
				<v-expansion-panel
					v-for="specialtyMaterial in specialtyMaterials"
					:key="specialtyMaterial.id"
				>
					<v-expansion-panel-header class="px-3">
						<div class="me-2 flex-grow-0">
							<v-icon>mdi-medication-outline</v-icon>
						</div>
						<div>{{getSpecialtyById(specialtyMaterial.specialtyId)?.name}}</div>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="px-0">
						<v-simple-table dense>
							<tbody>
								<template v-for="workload in specialtyMaterial.workloads">
									<tr
										v-for="(material, index) in workload.materials"
										:key="material.materialId"
									>
										<td
											v-if="index === 0"
											:rowspan="workload.materials.length"
											:key="index"
											class="px-2 primary--text font-weight-medium"
											style="width: 40px; min-width: 40px;"

										>
											{{getWorkloadById(workload.workloadId)?.name}}
										</td>
										<td class="px-2">{{ getMaterialById(material.materialId)?.name }}</td>
										<td class="px-2">{{ material.amount }}</td>
									</tr>
								</template>

								<tr
									v-for="material in specialtyMaterial.materials"
									:key="material.materialId"
									style="width: 40px; min-width: 40px;"
								>
									<td class="px-2 primary--text font-weight-medium">
										{{ getMaterialById(material.materialId)?.name }}
									</td>
									<td class="px-2">{{ material.amount }}</td>
								</tr>
							</tbody>
						</v-simple-table>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>

			<div
				v-else
				class="d-flex flex-column justify-center align-center"
				style="height: 45vh"
			>
				<v-icon x-large class="mb-3">mdi-medication</v-icon>
				<span class="d-flex flex-column justify-center align-center grey--text text-body-1">
					{{$T('no-specialty-materials-to-show')}}
				</span>
			</div>
		</v-container>
	</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
export default {
	name: 'SpecialtyVisitMaterials',

	components: { Loader },
	data() {
		return { 
			moment,
			loading: false,
		}
	},

	computed: {
		...mapState({
			specialties: state => state.specialties.specialties,
			specialtyMaterials: state => state.materials.specialtyMaterials,
			workloads: state => state.workloads.workloads,
		}),

		...mapGetters({
			getSpecialtyById: 'specialties/getSpecialtyById',
			getWorkloadById: 'workloads/getWorkloadById',
			getMaterialById: 'materials/getMaterialById',
		})
	},

	created() {
		this.loading = true;
		Promise.all([
			!this.specialties.length ? this.$store.dispatch('specialties/fetchAll') : null,
			!this.workloads.length ? this.$store.dispatch('workloads/fetchAll') : null,
			this.$store.dispatch('materials/fetchAll', {}),
			!this.specialtyMaterials.length
				? this.$store.dispatch('materials/fetchAllForSpecialtyVisits', {
					fromDate: moment().startOf('month').format('YYYY-MM-DD'),
					toDate: moment().endOf('month').format('YYYY-MM-DD'),
				})
				: null,
		]).finally(() => {
			this.loading = false;
		});
	}
}
</script>

<style lang="scss">
#specialty-visit-materials {
	.v-expansion-panel-content__wrap {
		padding: 0 14px;
	}
}
</style>